import Portfolio from "./components/portfolio/Portfolio";

function App() {
  return <Portfolio />;
}

export default App;
